<div id="widget-modal" rvSpinner="widget-modal-loader" [rvShowSpinner]="loading">
  @if (widgetUrl) {
    <iframe id="widget-modal-frame" name="widget-modal-frame" class="full-screen" scrolling="no" marginwidth="0" [src]="widgetUrl"></iframe>
  }
</div>
